/* @flow */
import * as React from 'react';
import Loading from '../Loading/Loading';
import ActionDrawerStore from 'stores/ActionDrawerStore';
import { inject, observer } from 'mobx-react';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from './LoadingWrapper.module.scss';
import uuidv4 from 'uuid/v4';

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
};

export type LoadingWrapperProps = {
  type: string,
  children: (string, boolean) => void,
  auto: boolean,
};

@inject('actionDrawerStore')
@observer
export default class LoadingWrapper extends ComponentWithInjectedProps<
  LoadingWrapperProps,
  {},
  InjectedProps
> {
  uuid = uuidv4();

  static defaultProps = {
    auto: true,
  };

  constructor(props) {
    super(props);

    this.loadingKey = false;
  }

  get loadingKey() {
    const { type } = this.props;

    return `${type}-${this.uuid}`;
  }

  set loadingKey(value) {
    const { actionDrawerStore } = this.props;

    actionDrawerStore.setLoadingEntry(this.loadingKey, value);
  }

  render() {
    const { children, auto, actionDrawerStore, classes } = this.props;
    const className = auto ? `${styles.loadingWrapper} ${styles.auto}` : styles.loadingWrapper;
    const isLoading = actionDrawerStore.getLoadingEntry(this.loadingKey);

    return (
      <React.Fragment>
        {isLoading ? (
          <div className={`${className} ${classes}`}>
            <Loading size={'small'} />
          </div>
        ) : (
          children(this.loadingKey, isLoading)
        )}
      </React.Fragment>
    );
  }
}
